<template>
  <span class="header-selector i-menu-expanded"
       @click="$emit('update:isOpen', !isOpen)"
  />
</template>

<script>
  export default {
    name: 'header-selector',
    props: {
      isOpen: {
        type: Boolean,
        required: true
      },
    }
  }
</script>

<style lang="scss">

  	.header-selector {
    	@include flex-center();
    	cursor: pointer;
  	}

	.profile-dropdown {
		.nav-link {
			color: #fff;
		}
    	.plain-link-item {
      		a {
        		color: #fff;
			  }
			  &:hover {
				  background-color: $lighter-blue !important;
			  }
    	}
  	}

</style>



// WEBPACK FOOTER //
// src/components/admin/app-navbar/components/HeaderSelector.vue